"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDropzone = _interopRequireDefault(require("react-dropzone"));

var _Button = _interopRequireDefault(require("../button/Button"));

var _classnames = _interopRequireDefault(require("classnames"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var FilePicker = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(FilePicker, _Component);

  var _super = _createSuper(FilePicker);

  function FilePicker() {
    (0, _classCallCheck2.default)(this, FilePicker);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(FilePicker, [{
    key: "render",
    value: function render() {
      var _this = this;

      var dropzoneProps = {
        accept: this.props.accept,
        multiple: this.props.multiple,
        ref: function ref(thisDropzone) {
          _this.thisDropzone = thisDropzone;
        },
        onDrop: this.onPick.bind(this),
        maxSize: this.props.maxSize
      }; //let content;
      // TODO Reactivate once the dropzone is available
      // if (this.props.displayMode === 'dropzone') {
      //     //Dropzone
      //     // TODO className and activeClassName/rejectClassName are deprecated.
      //     // TODO They will have to be replaced respectively with parent div styling and
      //     // TODO child div styling with function.
      //     // TODO This is not possible yet because this Dropzone version still contains a default styling.
      //     dropzoneProps = {
      //         className: classNames('react-dropzone', this.props.className),
      //         activeClassName: 'react-dropzone-active',
      //         rejectClassName: 'react-dropzone-rejected',
      //         ...dropzoneProps,
      //     };
      //     content = <Dropzone {...dropzoneProps} />;
      // } else {
      // Button
      // TODO className will be deprecated in the following major release.
      // TODO It will have to be replaced with parent div styling,
      // TODO This is not possible yet because this Dropzone version still contains a default styling.

      dropzoneProps = _objectSpread({
        className: (0, _classnames.default)('invisible')
      }, dropzoneProps);

      var content = /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_reactDropzone.default, dropzoneProps), /*#__PURE__*/_react.default.createElement(_Button.default, {
        onClick: this.onOpenClick.bind(this),
        className: this.props.className
      }, this.props.label)); // }


      return /*#__PURE__*/_react.default.createElement("div", {
        className: "FilePicker"
      }, content);
    }
  }, {
    key: "onPick",
    value: function onPick(acceptedFiles, rejectedFiles) {
      this.props.onPick(acceptedFiles, rejectedFiles);
    }
  }, {
    key: "onOpenClick",
    value: function onOpenClick() {
      this.thisDropzone.open();
    }
  }]);
  return FilePicker;
}(_react.Component);

exports.default = FilePicker;
FilePicker.defaultProps = {
  displayMode: 'button',
  multiple: true,
  label: 'Select file(s)',
  accept: '',
  onPick: function onPick() {},
  className: ''
};
FilePicker.propTypes = {
  displayMode: _propTypes.default.string
  /* Display mode: 'dropzone' / 'button' */
  ,
  multiple: _propTypes.default.bool
  /* Allow multiple file selections or not */
  ,
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node])
  /* Text to display on Button */
  ,
  accept: _propTypes.default.string
  /* List of accepted Mime Types */
  ,
  maxSize: _propTypes.default.number
  /* Maximum File Size */
  ,
  onPick: _propTypes.default.func
  /* Pick callback */
  ,
  className: _propTypes.default.string
  /* Custom className for the displayed component (dropzone/button) */

};